/**
 * @author Jorge Casas
 * @creationDate 22/04/2024
 */

import { formatMoney } from 'accounting-js';
import React from 'react';
import { formatDate } from '../../../../utils/additional-functions/formatted-date.js';
import { translate } from 'react-i18next';

/**
 * @function statusRendering
 *
 * @description This function is used to render the status of the customs documents
 *
 * @param {Number} statusId
 * @param {Object} catalogs
 * @returns {String}
 *
 */
const statusRendering = (statusId, catalogs) => {
  try {
    if (catalogs && catalogs.customsDocumentsStatus) {
      const status = catalogs.customsDocumentsStatus.find((item) => item.id === statusId);
      return status ? status.value : '-';
    }
    return '-';
  } catch (error) {
    return '-';
  }
};

/**
 * @function AssetCustomsDocumentsRow
 *
 * @description This function is used to render a row in the table of customs documents
 *
 * @param {Object} props
 * @param {Object} props.customsDocuments
 * @returns {React.Component}
 */
const AssetCustomsDocumentsRow = ({ customsDocuments, catalogs, t = () => {} }) => {
  const translations = statusRendering(customsDocuments.customsDocumentsStatus, catalogs);

  const renderRows = () => {
    if (
      customsDocuments.customsDocumentsFiles &&
      customsDocuments.customsDocumentsFiles.length > 0
    ) {
      return customsDocuments.customsDocumentsFiles.map((file) => (
        <div key={file._id}>
          {file.url.toLowerCase().endsWith('.pdf') ? (
            <div style={{ position: "relative" }}>
              <a target="_blank" href={file.url} style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}></a>
              <embed src={file.url} type="application/pdf" width="117%" height="145px" />
            </div>
          ) : file.url.toLowerCase().endsWith('.jpg') ||
            file.url.toLowerCase().endsWith('.jpeg') ||
            file.url.toLowerCase().endsWith('.png') ||
            file.url.toLowerCase().endsWith('.gif') ? (
            <a target="_blank" href={file.url}>
              <img src={file.url} alt={`${file.name} Preview`} width="109%" height="155px" />
            </a>
          ) : (
            <div>Archivo no compatible</div>
          )}
        </div>
      ));
    } else {
      return (
        <tr>
          <td colSpan="5">
            <div className="alert alert-info text-center mb-0">
              <i className="fa fa-lg fa-info-circle pr-3" />
              {t('files.empty')}
            </div>
          </td>
        </tr>
      );
    }
  };
  

  return (
    <tr>
      <td className="align-middle">{customsDocuments.customsDocumentsPedimentoNumber || '-'}</td>
      <td className="align-middle">{customsDocuments.customsDocumentsPedimentoKey || '-'}</td>
      <td className="align-middle">{customsDocuments.customsDocumentsCustomsKey || '-'}</td>
      <td className="align-middle">
        {customsDocuments.customsDocumentsDate
          ? formatDate(customsDocuments.customsDocumentsDate)
          : '-'}
      </td>
      <td className="align-middle">
        {customsDocuments.customsDocumentsStatus && translations ? t(translations) : '-'}
      </td>
      <td className="align-middle">
        {customsDocuments.customsDocumentsImport
          ? formatMoney(customsDocuments.customsDocumentsImport / 100)
          : '-'}
      </td>
      <td className="align-middle">{customsDocuments.customsDocumentsQuantity || '-'}</td>
      <td className="align-middle">{renderRows()}</td>
      <td className="align-middle">
        {customsDocuments.createdAt ? formatDate(customsDocuments.createdAt) : '-'}
      </td>
    </tr>
  );
};

export default translate()(AssetCustomsDocumentsRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/assets/AssetsCustomsDocsRow.js